import {useCallback, useState} from 'react'
import { useAPI } from '../hoc/useAPI';


export const useGetGlasses=()=>{
const ENDPOINTS = useAPI()

    const [glassesData,setData]=useState<any[]>([])
    const [glassesDataLoading,setIsLoading]=useState(false)
    const [glassesError,setError]=useState('')
const getGlasses=useCallback((page:number)=>{
    setIsLoading(true)
ENDPOINTS.glasses()
        .index({page,page_size:1000,sort_field: 33,sort_direction:'ASC'})
        .then((res:any)=>{
           
            if (res.data && res.data.data && res.data.data.glasses) {
                setData (res.data.data.glasses)
                setIsLoading(false)
            }
            else {
                setData([])
                setIsLoading(false)
            }
        })
        .catch((err:any)=>{
            setIsLoading(false)
            setError(err)
        })
  
},[ENDPOINTS])
    return {getGlasses,glassesData,glassesDataLoading,glassesError}
}